import React from 'react';
import { CaretLeftIcon, CaretRightIcon } from '@phosphor-icons/react';

interface TrimmerHandleProps {
    side: 'left' | 'right';
    position: number;
    onMouseDown: (e: React.MouseEvent) => void;
}

export function TrimmerHandle({
    side,
    position,
    onMouseDown,
}: TrimmerHandleProps) {
    const Icon = side === 'left' ? CaretLeftIcon : CaretRightIcon;
    const roundedClass =
        side === 'left' ? 'rounded-l-[4px]' : 'rounded-r-[4px]';
    const adjustedPosition = side === 'right' ? position - 16 : position;

    return (
        <div
            className={`absolute top-0 bottom-0 w-4 cursor-ew-resize flex items-center justify-center bg-white z-10 ${roundedClass}`}
            style={{ left: `${adjustedPosition}px` }}
            onMouseDown={onMouseDown}
        >
            <Icon weight="fill" className="w-3 h-3 text-grey-900" />
        </div>
    );
}
